/**
 * Export utilities for Doorly Desk reports
 */

// Export data as CSV download
export const exportCSV = (data, columns, filename) => {
  const headers = columns.map((c) => c.label).join(',');
  const rows = data.map((row) =>
    columns.map((c) => {
      const val = c.accessor ? c.accessor(row) : (row[c.key] ?? '');
      const str = String(val).replace(/"/g, '""');
      return str.includes(',') || str.includes('"') || str.includes('\n') ? `"${str}"` : str;
    }).join(',')
  );
  const csv = [headers, ...rows].join('\n');
  downloadFile(csv, filename + '.csv', 'text/csv');
};

// Export data as JSON download
export const exportJSON = (data, filename) => {
  downloadFile(JSON.stringify(data, null, 2), filename + '.json', 'application/json');
};

const downloadFile = (content, filename, type) => {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

// Get today's date string for filenames
export const todayStr = () => new Date().toISOString().slice(0, 10);
